<template>
  <div>
    <h1>添加文章</h1>
    <h2>fwefwefw</h2>

    <el-card>
      <h2>段落</h2>
      <el-row>
        <el-input type="textarea"
                  v-model="textarea"
                  :autosize="true"></el-input>
      </el-row>
      <el-row>
        <el-button type="primary"
                   v-on:click="render()">生成</el-button>
      </el-row>
    </el-card>
    <el-card>
      <h2>副标题</h2>
      <el-row>
        <el-input type="textarea"
                  v-model="textarea2"
                  :autosize="true"></el-input>
      </el-row>
      <el-row>
        <el-button type="primary"
                   v-on:click="renderSubtitle()">生成</el-button>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {},
  beforeMount() {
    const password = this.$route.query.password
    // console.log('debug', password, !(password === 'hcbl'))
    if (!(password === 'hcbl')) {
      // console.log('密码不正确')
      this.$router.push({ path: '/404' })
    }
  },
  data() {
    return {
      textarea: '',
      textarea2: ''
    }
  },
  methods: {
    render() {
      const arr = this.textarea.split('\n').filter(d => d.trim() !== '')
      const data = arr.map(item => {
        return {
          type: 'paragraph',
          value: item
        }
      })
      data.push({ test: 1 })
      // console.log('生成数据', data)
      console.log(JSON.stringify(data, null, 2))
    },
    renderSubtitle() {
      const arr = this.textarea2.split('\n').filter(d => d.trim() !== '')
      const data = arr.map((item, index) => {
        if (index % 2 === 0) {
          return {
            type: 'subtitle',
            value: item
          }
        } else {
          return {
            type: 'paragraph',
            value: item
          }
        }
      })
      data.push({ end: 1 })
      // console.log('生成数据', data)
      console.log(JSON.stringify(data, null, 2))
    }
  }
}
</script>

<style lang="scss" scoped></style>
